/*
	Логинизациия в приложении
	Токены из ответа автоматически прикрепляется к cookies (обработка не нужна)
*/
import { IResponse } from "../../types/response.type";
import { apiRequest } from "../http";

// Данные ответа при успешной логинизации
interface SuccessResponseData {
	success: boolean;
	buyer_id: number;
	email: string;
	username: string;
	session_token: string; // Будет убран в будущем
	auto_accept_apps: boolean;
}
// Типизированный ответ
export type ILoginResponse = IResponse<SuccessResponseData>;

export const login = async (body: {
	email: string;
	password: string;
}): Promise<ILoginResponse> => {
	return await apiRequest<SuccessResponseData>({
		path: "/api/v1/auth/login",
		method: "POST",
		json: body,
	});
};
